import { styled } from '@mui/material/styles';
import { IconButton } from '@mui/material';
import { Icon, SvgName } from 'components/Icon';
const urlQrLine = import.meta.env.VITE_QR_LINE;

// -----------------------------------------------------------------------

const StyleIconButton = styled(IconButton, {
  shouldForwardProp: prop => prop !== 'mobilePosition',
})<{ mobilePosition?: 'sticky' | 'fixed' }>(
  ({ mobilePosition = 'sticky' }) => ({
    position: 'absolute',
    left: '1.8rem',
    bottom: '1.5rem',
    color: '#919EAB',
    backgroundColor: '#06C755',
    width: '48px',
    height: '48px',
    borderRadius: '200px',
    border: '1px solid #DFE3E8',
    boxShadow:
      ' 0px 12px 24px -4px rgba(145, 158, 171, 0.12), 0px 0px 2px 0px rgba(145, 158, 171, 0.20)',
    '@media(max-width: 1024px)': {
      position: mobilePosition,
      left: '1.5rem',
    },
  }),
);

const StyledLineIcon = styled('div')(() => ({
  width: '36px',
  height: '36px',
  top: '8px',
  position: 'absolute',
}));

const handleRedirectQR = () => {
  window.open(`${urlQrLine}`, '_blank');
};

interface INavbarQRProps {
  mobilePosition?: 'sticky' | 'fixed';
}

// -----------------------------------------------------------------------
export default function NavbarQR({ mobilePosition }: INavbarQRProps) {
  const iconLineBackgroundStyle: React.CSSProperties = {
    backgroundColor: 'white',
    position: 'relative',
    width: '32.4px',
    height: '30.87px',
  };
  const iconLineStyle: React.CSSProperties = {
    width: '22px',
    height: '7.69px',
    backgroundColor: '#06C755',
    position: 'relative',
    top: '-41px',
  };
  return (
    <StyleIconButton
      disableRipple
      onClick={handleRedirectQR}
      mobilePosition={mobilePosition}
    >
      <StyledLineIcon>
        <Icon name={SvgName.LineBackground} sx={iconLineBackgroundStyle} />
        <Icon name={SvgName.Line} sx={iconLineStyle} />
      </StyledLineIcon>
    </StyleIconButton>
  );
}
